import React, { ReactNode } from "react";
import { Box, ButtonBase, ListItemText } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CheckIcon from "@material-ui/icons/Check";
import { StyledMenu, StyledMenuItem } from "./StyledMenu";
import { tesaGrey1 } from "../../styles/colors";

export interface Selectable {
  id: string;
  label: string;
}

export interface CustomContextMenuProps<T extends Selectable> {
  data: T[];
  active?: string;
  onMenuItemClick: (selectable: T) => void;
  buttonContent?: (handleClick: (event: React.MouseEvent<HTMLElement>) => void) => ReactNode;
}

function CustomContextMenu<T extends Selectable>(props: CustomContextMenuProps<T>): JSX.Element {
  const { active, data, onMenuItemClick, buttonContent } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const hasActive = !!active;

  return (
    <>
      {buttonContent?.(handleClick) || (
        <ButtonBase onClick={handleClick}>
          <AddIcon fontSize="small" htmlColor={tesaGrey1} />
        </ButtonBase>
      )}
      <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {data.length > 0 ? (
          data.map((e) => {
            return (
              <StyledMenuItem
                key={`CustomContextMenu_item-${e.id}`}
                onClick={(): void => {
                  onMenuItemClick(e);
                  handleClose();
                }}
              >
                <ListItemText
                  primary={
                    <Box display="flex" flexDirection="row">
                      {hasActive && <Box width={30}>{e.id === active && <CheckIcon fontSize="small" />}</Box>}
                      <Box>{e.label}</Box>
                    </Box>
                  }
                />
              </StyledMenuItem>
            );
          })
        ) : (
          <StyledMenuItem
            key="ustomDynamicContextMenu_empty"
            onClick={(): void => {
              handleClose();
            }}
          >
            <ListItemText primary="- No options - " />
          </StyledMenuItem>
        )}
      </StyledMenu>
    </>
  );
}

export default CustomContextMenu;
